import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dimensionsDataSelector } from "@/store/dimensions/selectors/dimensions-data/dimensionsDataSelector";
import { DimensionsWithChildren } from "@/store/dimensions/utils/types/common";

export const dimensionsGridDataSelector = createDraftSafeSelector(
  [dimensionsDataSelector],
  (data): DimensionsWithChildren[] | undefined => {
    return data?.map((dimension) => ({
      ...dimension,
      children: dimension.categories.map((category) => ({
        ...category,
        dimensionId: dimension.id,
      })),
    }));
  },
);
